"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _lodash = require("lodash");
var _Anchor = _interopRequireDefault(require("../../Atoms/Anchor"));
require("./BaseLinksFooter.scss");
var legalSection = function legalSection(baseFooterData) {
  return _react.default.createElement("div", {
    className: "cmp-footer__links china-legal"
  }, _react.default.createElement("a", {
    href: baseFooterData.sICPLegalLink,
    className: "cmp-footer__china-legal-sICP"
  }, baseFooterData.sICPLegalIcon && _react.default.createElement("img", {
    src: baseFooterData.sICPLegalIcon,
    alt: "Shanghai ICP Number Legal Icon"
  }), baseFooterData.sICPNumber && _react.default.createElement("span", null, "\u6CAAICP\u5907" + baseFooterData.sICPNumber + "\u53F7-2")), _react.default.createElement("a", {
    href: baseFooterData.bPNSLegalLink,
    className: "cmp-footer__china-legal-bPNS"
  }, baseFooterData.bPNSLegalIcon && _react.default.createElement("img", {
    src: baseFooterData.bPNSLegalIcon,
    alt: "Beijing Public Network Security Number Legal Icon"
  }), baseFooterData.bPNSNumber && _react.default.createElement("span", null, "\u4EAC\u516C\u7F51\u5B89\u5907" + baseFooterData.bPNSNumber + "\u53F7")), _react.default.createElement("a", {
    href: baseFooterData.cBLegalLink,
    className: "cmp-footer__china-legal-cB"
  }, baseFooterData.cBLegalIcon && _react.default.createElement("img", {
    src: baseFooterData.cBLegalIcon,
    alt: "Commercial Bureau Legal Icon"
  })));
};
var BaseLinksFooter = function BaseLinksFooter(baseFooterData) {
  var basefooterLinks = (0, _lodash.get)(baseFooterData, ['footerLinks'], {});
  var countryName = (0, _lodash.get)(baseFooterData, 'countryName', '');
  var showLegalIcon = baseFooterData.showLegalIcon || countryName === 'China';
  return _react.default.createElement("div", {
    className: "baseLinksFooter"
  }, _react.default.createElement("div", {
    className: "baseLinksFooter container"
  }, _react.default.createElement("div", {
    className: "footer__copyright",
    "data-locator": "footer-copyright"
  }, baseFooterData && _react.default.createElement("p", null, baseFooterData.labels.watersCopyRight)), _react.default.createElement("div", {
    className: "footer__links"
  }, baseFooterData && _react.default.createElement("nav", null, Object.keys(basefooterLinks).map(function (item) {
    var linksText = basefooterLinks[item].text; // handle unnecessary payload which are not being used.
    // as link has text and link only

    return !(0, _lodash.isEmpty)(linksText) && _react.default.createElement(_Anchor.default, {
      href: basefooterLinks[item].link,
      key: item
    }, linksText);
  }), baseFooterData.cookiesLink && _react.default.createElement(_Anchor.default, {
    href: baseFooterData.cookiesLink
  }, baseFooterData.labels.cookies), _react.default.createElement(_Anchor.default, {
    className: "optanon-toggle-display dl_Anchor",
    href: "#"
  }, baseFooterData.labels.cookiePreferences), showLegalIcon && legalSection(baseFooterData)))));
};
BaseLinksFooter.defaultProps = {
  baseFooterData: {}
};
var _default = BaseLinksFooter;
exports.default = _default;
module.exports = exports["default"];